<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="#pablo">{{ routeName }}</a>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <div
        class="search-bar input-group"
        style="padding: 15px"
        @click="searchModalVisible = true"
      >
        <p>{{ username }}</p>
        <!-- <i class="tim-icons icon-zoom-split"></i> -->
      </div>

      <!-- <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        title-classes="nav-link"
        class="nav-item"
      > -->
      <!-- <template
          slot="title"
        >
          <div class="d-none d-lg-block d-xl-block" :class="noti">
            {{ totalNoti }}
          </div>
          <i class="tim-icons icon-bell-55"></i>
          <p class="d-lg-none">New Notifications</p>
        </template>
        <li class="nav-link" v-for="item in notifications" :key="item.id">
          <a :href="href" class="nav-item dropdown-item">
            {{ item.message }}
            </a>
        </li> -->
      <!-- <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">You have 5 more tasks</a>
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item"
            >Your friend Michael is in town</a
          >
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">Another notification</a>
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">Another one</a>
        </li> -->
      <!-- </base-dropdown> -->
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template slot="title">
          <div class="row"></div>
          <div class="photo"><img src="img/default-avatar.png" /></div>

          <b class="caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">Log out</p>
        </template>
        <!-- <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">Profile</a>
        </li>
        <li class="nav-link">
          <a href="#" class="nav-item dropdown-item">Settings</a>
        </li> -->
        <!-- <div class="dropdown-divider"></div> -->
        <!-- <li class="nav-link">
          <a class="nav-item dropdown-item" @click="logout()">User Profile</a>
        </li> -->
        <!-- <hr/> -->
        <li class="nav-link">
          <a class="nav-item dropdown-item" @click="logout()">Log out</a>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import SidebarToggleButton from "./SidebarToggleButton";

export default {
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal,
  },
  created() {},
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
  data() {
    return {
      username: "Haziq Haikal Bin Ayub",
      // notification
      noti: "notification",
      notifications: [
        {
          id: 1,
          message: "Error message 1",
        },
        {
          id: 2,
          message: "Error message 2",
        },
      ],
      totalNoti: 2,
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  created() {
    this.username = sessionStorage.getItem("username");
  },
  methods: {
    logout() {
      this.$http
        .post(":8002/api/v1/auth/logout")
        .then((res) => {
          sessionStorage.removeItem("token", res.message.jwt_token);
          this.$cookie.remove("token");
          this.$router.push("/login");
        })
        .catch((err) => {
         
        });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
  },
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
hr {
  margin-top: 2%;
  margin-bottom: 0%;
}
</style>
